import React from 'react'
import { Card } from 'react-bootstrap'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { reduxForm } from 'redux-form'
import { FORM_SOLICITUD_ACCESO } from '../../../config/forms'
import { INTERVALO_CORTO } from '../../../config/settings'
import { submitSolicitudAcceso } from '../actions'
import pdf from '../../../static/solicitud_de_acceso_usuario_externo.pdf'

function FormularioSolicitudUsuario (props) {
  const dir = 'sistemas@terminalquequen.com.ar'

  // const submitForm = () => {
  //   const { nombre, rol, email, cuitEmpresa, razonSocialEmpresa } = props
  //   if (nombre) {
  //     if (email) {
  //       if (rol) {
  //         if (cuitEmpresa && razonSocialEmpresa) {
  //           props.submitSolicitudAcceso()
  //           props.handleCloseForm()
  //         } else {
  //           toast.error('Debe ingresar el CUIT y la razón social de la empresa')
  //         }
  //       } else {
  //         toast.error('Debe seleccionar un rol')
  //       }
  //     } else {
  //       toast.error('Debe ingresar su correo electrónico para enviar la solicitud')
  //     }
  //   } else {
  //     toast.error('Debe ingresar su nombre y apellido')
  //   }
  // }

  return (
    <div style={{ padding: '2% 4%' }}>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <div style={{ marginBottom: '4%' }}>
        <p>Para solicitar acceso a un nuevo usuario en Laridae, puede descargar aqui el formulario que deberá completar y enviar a {dir}</p>
      </div>
      <Card className='shadow bg-white rounded' style={{ padding: '18px' }}>
        <iframe
          title='pdf-solicitud-acceso-laridae'
          src={pdf}
          style={{ minHeight: '70vh' }}
        />

        {/* <div style={{ margin: '2% 0' }}>
          <CamposSolicitudUsuario rol={props.rol} />
        </div> */}
        {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            onClick={submitForm}
            variant='contained'
            size='small'
            color='primary'
            style={{ outline: 'none' }}
          >
                        Enviar solicitud
          </Button>
        </div> */}
      </Card>

    </div>
  )
}

// const selector = formValueSelector(FORM_SOLICITUD_ACCESO)

const mapStateToProps = (state) => {
  return {
    // nombre: selector(state, 'nombre'),
    // email: selector(state, 'email'),
    // telefono: selector(state, 'telefono'),
    // rol: selector(state, 'rol'),
    // cuitEmpresa: selector(state, 'cuitEmpresa'),
    // razonSocialEmpresa: selector(state, 'razonSocialEmpresa')
  }
}
const mapActionsToProps = {
  submitSolicitudAcceso
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_SOLICITUD_ACCESO
})

export default withRedux(withReduxForm(FormularioSolicitudUsuario))
